import {
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Button,
  Space,
  Text,
  Flex,
  Stack,
} from '@tonic-one/react';
import { t } from 'i18next';
import { CorrelatedExpressionShallow } from '../types';
import { FormLabel } from '@Components/Common/FormComponent';
import LoadingBtn from '@Components/Common/LoadingBtn';

const DeleteExpressionModal = (props: {
  expression: CorrelatedExpressionShallow;
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) => {
  const { expression, isOpen, onClose, onConfirm } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      closeOnEsc
      closeOnOutsideClick
      isClosable
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          {t('globalSetting.correlatedExpressions.deleteExpressionModal.title')}
        </ModalHeader>
        <ModalBody>
          <Stack gap="4x">
            <Text>
              {t(
                'globalSetting.correlatedExpressions.deleteExpressionModal.content'
              )}
            </Text>
            <Flex>
              <FormLabel
                label={t(
                  'globalSetting.correlatedExpressions.table.filterName'
                )}
              />
              <Text height="max-content" alignSelf="center">
                {expression.raiExpName}
              </Text>
            </Flex>
            {expression.raiExpDesc !== '' && (
              <Flex>
                <FormLabel
                  label={t(
                    'globalSetting.correlatedExpressions.table.description'
                  )}
                />
                <Text height="max-content" alignSelf="center">
                  {expression.raiExpDesc}
                </Text>
              </Flex>
            )}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn variant="primary" onClick={onConfirm}>
            {t('common.action.label.delete')}
          </LoadingBtn>
          <Space width="2x" />
          <Button onClick={onClose}>{t('common.button.cancel')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteExpressionModal;
